/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import {useEffect, useRef} from 'react';
import {useSelector} from 'react-redux';
import {showAssetsListSelector} from '@/store/selectors/tracking-selectors';

/**
 * Provides a utility hook to retrieves the .
 *
 * ```typescript
 *  import {useAssetListState} from '../../hooks/useAssetListState';
 *
 *   const showAssetsListRef = useAssetListState();
 *
 * ```
 */
export const useAssetListState = () => {
  const showAssetsList    = useSelector(showAssetsListSelector);
  const showAssetsListRef = useRef(showAssetsList);

  useEffect(() => {
    showAssetsListRef.current = showAssetsList;
  }, [showAssetsList]);

  return showAssetsListRef;
};
